import { useEffect } from "react";
import { Route, Routes, useNavigate } from 'react-router-dom';
import DashboardCalendar from './DashboardCalendar';
import DashboardInformation from "./DashboardInformation";

const Dashboard = (props) => {
    const { isLoggedIn } = props;
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn) {
            navigate("/login");
        }
    }, [isLoggedIn, navigate]);

    return (
        <div className="rb-dashboard">
            <Routes>
                <Route path="book-class" element={<DashboardCalendar />} />
                <Route path="view-booked-classes" element={<DashboardInformation />} />
            </Routes>
        </div>
    );
};

export default Dashboard;
